import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import MessagingScreen from '../screen'

const GoalRoutes = () => {

    return (
        <React.Fragment>
            <Route exact path={CLIENT_ENDPOINTS.MESSAGE_CREATE} component={MessagingScreen} />
        </React.Fragment>
    )
}

export default GoalRoutes